const mediaqueries = {
  xs: '@media (max-width: 419px)',
  sm: '@media (max-width: 549px)',
  md: '@media (max-width: 1023px)',
  lg: '@media (max-width: 1599px)',
  xl: '@media (max-width: 1919px)',
};

export const getMediaqueryStyled = (mq: keyof typeof mediaqueries) => {
  return mediaqueries[mq];
};
